import * as React from 'react';
import { useSelector } from 'react-redux';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { textbausteineByKzNrSelector, textbausteineByKzSelector } from 'store/lookups/selector';
import { MenuPlacement } from 'react-select/src/types';

interface TextbausteinProps {
    label: string;
    disabled: boolean;
    kz: number;
    value: number | null;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    onChange: (newValue: string) => void;
}

export const Textbaustein: React.FC<TextbausteinProps> = ({
    label,
    kz,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    onChange,
}) => {
    const textbausteineByKz = useSelector(textbausteineByKzSelector);
    const textbausteineByKzNr = useSelector(textbausteineByKzNrSelector);

    const options = React.useMemo(() => {
        const o = textbausteineByKz[kz].map((t) => ({
            value: t.nr.toString(),
            label: t.name,
        }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [textbausteineByKz, kz, allowEmpty]);

    return (
        <>
            <Label>{label}</Label>
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: textbausteineByKzNr[kz]?.[value]?.name || value.toString(),
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '  ');
                }}
            />
        </>
    );
};
